import ArticlePage19Img from '../../images/04755.png';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

function ArticlePage19() {
  useEffect(() => {
    function isGoogleTranslated() {
      const html = document.documentElement;
      const body = document.body;

      return (
        html.classList.contains('translated-ltr') ||
        html.classList.contains('translated-rtl') ||
        body.classList.contains('translated-ltr') ||
        body.classList.contains('translated-rtl') ||
        document.cookie.indexOf('googtrans=') !== -1 ||
        html.getAttribute('lang') !== 'ru'
      );
    }

    function fixValue(text) {
      if (!text) return text;

      return text
        .replace(/\bRoman Shlykov's\b/g, "Roman Shlykov's")
        .replace(/\bROMAN SHLYKOV'S\b/g, "ROMAN SHLYKOV'S")
        .replace(/\bRoman Shlykov\b/g, 'Roman Shlykov')
        .replace(/\bROMAN SHLYKOV\b/g, 'ROMAN SHLYKOV')
        .replace(/\bRoman's\b/g, "Roman's")
        .replace(/\bROMAN'S\b/g, "ROMAN'S")
        .replace(/\bRoman\b/g, 'Roman')
        .replace(/\bROMAN\b/g, 'ROMAN');
    }

    function shouldSkipNode(parent) {
      if (!parent || !parent.tagName) return true;

      const tag = parent.tagName.toUpperCase();
      return (
        tag === 'SCRIPT' ||
        tag === 'STYLE' ||
        tag === 'NOSCRIPT' ||
        tag === 'TEXTAREA' ||
        tag === 'CODE' ||
        tag === 'PRE'
      );
    }

    function fixTextNodes(root) {
      if (!root) return;

      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (!node || !node.nodeValue || !node.nodeValue.trim()) {
              return NodeFilter.FILTER_REJECT;
            }

            if (shouldSkipNode(node.parentNode)) {
              return NodeFilter.FILTER_REJECT;
            }

            if (
              node.nodeValue.indexOf('Roman') === -1 &&
              node.nodeValue.indexOf('ROMAN') === -1
            ) {
              return NodeFilter.FILTER_REJECT;
            }

            return NodeFilter.FILTER_ACCEPT;
          },
        }
      );

      const nodes = [];
      let current;

      while ((current = walker.nextNode())) {
        nodes.push(current);
      }

      nodes.forEach((node) => {
        const fixed = fixValue(node.nodeValue);
        if (fixed !== node.nodeValue) {
          node.nodeValue = fixed;
        }
      });
    }

    function fixAttributes() {
      const selectors = [
        'title',
        'meta[name="description"]',
        'meta[name="keywords"]',
        'meta[property="og:title"]',
        'meta[property="og:description"]',
        'meta[name="twitter:title"]',
        'meta[name="twitter:description"]',
      ];

      selectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (el.tagName.toLowerCase() === 'title') {
            const fixedText = fixValue(el.textContent);
            if (fixedText !== el.textContent) {
              el.textContent = fixedText;
            }
          } else {
            const content = el.getAttribute('content');
            const fixedContent = fixValue(content);
            if (fixedContent !== content) {
              el.setAttribute('content', fixedContent);
            }
          }
        });
      });

      if (document.title) {
        const fixedTitle = fixValue(document.title);
        if (fixedTitle !== document.title) {
          document.title = fixedTitle;
        }
      }
    }

    function runFixes() {
      if (!isGoogleTranslated()) return;
      fixTextNodes(document.body);
      fixAttributes();
    }

    let started = false;
    let mainObserver = null;
    let pollInterval = null;
    let translationWatcher = null;

    function startAfterTranslate() {
      if (started) return;
      started = true;

      runFixes();

      mainObserver = new MutationObserver(() => {
        runFixes();
      });

      if (document.body) {
        mainObserver.observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      let count = 0;
      pollInterval = setInterval(() => {
        runFixes();
        count += 1;

        if (count > 180) {
          clearInterval(pollInterval);
        }
      }, 1000);
    }

    function waitForTranslate() {
      if (isGoogleTranslated()) {
        startAfterTranslate();
        return;
      }

      translationWatcher = new MutationObserver(() => {
        if (isGoogleTranslated()) {
          startAfterTranslate();
        }
      });

      translationWatcher.observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'lang'],
      });

      const translateCheckInterval = setInterval(() => {
        if (isGoogleTranslated()) {
          startAfterTranslate();
          clearInterval(translateCheckInterval);
        }
      }, 1000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForTranslate);
    } else {
      waitForTranslate();
    }

    return () => {
      if (mainObserver) mainObserver.disconnect();
      if (translationWatcher) translationWatcher.disconnect();
      if (pollInterval) clearInterval(pollInterval);
    };
  }, []);

  return (
    <div className="xContent p-box py-6">
      <Helmet>
        <title>
          Как технология Романа Шлыкова меняет маркетинг: зачем фиксировать клики, конверсии и ROI в распределенном реестре | Roman Shlykov
        </title>

        <meta
          name="description"
          content="Статья Ларисы Дудиной о том, как технология Романа Шлыкова (Roman Shlykov) меняет маркетинг: зачем фиксировать клики, конверсии и ROI в распределенном реестре и как блокчейн усиливает прозрачность маркетинговой аналитики."
        />

        <meta
          name="keywords"
          content="Роман Шлыков, Roman Shlykov, блокчейн в маркетинге, marketing analytics, ROI, конверсии, клики, distributed ledger, маркетинговая аналитика, Rozetka, MTS"
        />

        <link rel="canonical" href="https://marketing-association.com/article19" />

        <meta
          property="og:title"
          content="Как технология Романа Шлыкова меняет маркетинг | Roman Shlykov"
        />
        <meta
          property="og:description"
          content="Материал о том, зачем фиксировать клики, конверсии и ROI в распределенном реестре и как технология Roman Shlykov меняет подход к маркетинговой аналитике."
        />
        <meta property="og:url" content="https://marketing-association.com/article19" />
        <meta property="og:type" content="article" />
        <meta property="og:image" content="https://marketing-association.com/images/articlepage19.png" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Как технология Романа Шлыкова меняет маркетинг | Roman Shlykov"
        />
        <meta
          name="twitter:description"
          content="Статья о том, как Roman Shlykov предлагает фиксировать клики, конверсии и ROI в распределенном реестре и почему это меняет маркетинговую аналитику."
        />
        <meta name="twitter:image" content="https://marketing-association.com/images/articlepage19.png" />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'NewsArticle',
            headline:
              'Как технология Романа Шлыкова меняет маркетинг: зачем фиксировать клики, конверсии и ROI в распределенном реестре',
            alternativeHeadline:
              'How Roman Shlykov’s Technology Changes Marketing',
            description:
              'Статья Ларисы Дудиной о том, как технология Романа Шлыкова меняет подход к маркетинговой аналитике, делая клики, конверсии и ROI более прозрачными и проверяемыми.',
            inLanguage: 'ru',
            datePublished: '2023-12-18',
            dateModified: '2023-12-18',
            author: {
              '@type': 'Person',
              name: 'Лариса Дудина',
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': 'https://marketing-association.com/article19',
            },
            image: ['https://marketing-association.com/images/articlepage19.png'],
            mentions: [
              {
                '@type': 'Person',
                name: 'Roman Shlykov',
                alternateName: 'Роман Шлыков',
              },
            ],
          })}
        </script>
      </Helmet>

      <p className="has-text-left content wysiwyg p-1">18 декабря 2023 год</p>

      <h1 className="title is-font-title-regular has-text-centered has-text-var-blue p-1">
        Как технология Романа Шлыкова меняет маркетинг: зачем фиксировать клики, конверсии и ROI в распределенном реестре
      </h1>

      <div className="block flex_1">
        <div>
          <img
            src={ArticlePage19Img}
            alt="Лариса Дудина"
            className="img_class"
          />
        </div>

        <div className="content p-20 wysiwyg">
          <p className="has-text-left p-style">
            Об авторе
          </p>

          <p className="p-1">
            Лариса Дудина — признанный эксперт в области маркетинговых коммуникаций,
            digital-стратегий и оценки эффективности маркетинговых решений, обладающая
            более чем десятилетним профессиональным опытом. На протяжении многих лет она
            занимается анализом практик, которые определяют развитие современной маркетинговой
            индустрии, — от трансформации digital-инструментов и аналитических моделей до
            внедрения технологий, меняющих подход к измерению результата и управлению
            маркетинговой эффективностью.
          </p>

          <p className="p-1">
            Как автор и отраслевой эксперт, Лариса Дудина специализируется на освещении
            наиболее значимых профессиональных достижений, инновационных кейсов и
            технологических решений, формирующих актуальную маркетинговую повестку.
            В центре ее профессионального интереса — проекты, в которых маркетинг выступает
            не только средством коммуникации, но и инструментом стратегического роста,
            прозрачной аналитики и измеримого бизнес-результата.
          </p>
        </div>
      </div>

      <div className="content p-20 wysiwyg">
        <p className="p-1">
          У цифровой рекламы есть одна особенность, которую редко обсуждают вне профессиональной
          среды: почти вся отрасль живет на событиях, которые нельзя потрогать. Показ баннера,
          клик, переход, просмотр страницы, заявка, покупка, повторный визит, конверсия — все это
          существует в виде данных, которые собираются, передаются, сопоставляются и
          интерпретируются множеством разных систем. Маркетинг кажется точной дисциплиной именно
          потому, что у него есть цифры. Но чем больше в нем цифр, тем важнее становится вопрос не
          о количестве метрик, а о надежности самой цепочки их возникновения.
        </p>

        <p className="p-1">
          Проблема не в том, что рынку не хватает отчетов. Отчетов как раз слишком много.
          Проблема в том, что между первым рекламным контактом и финальным выводом об эффективности
          кампании лежит длинная техническая и организационная дистанция. На одном конце —
          пользователь, который увидел рекламу и совершил действие. На другом — бизнес, который
          через неделю, месяц или квартал пытается понять, сработали ли вложенные бюджеты. Между
          ними стоят рекламные платформы, аналитические системы, CRM, агентства, сквозная
          атрибуция, интеграции, выгрузки, ручные сверки, внутренние BI-инструменты и человеческая
          интерпретация. В такой архитектуре любой итоговый показатель зависит не только от
          реального поведения аудитории, но и от того, насколько надежно вся эта инфраструктура
          передала смысл исходных событий.
        </p>

        <p className="p-1">
          Именно здесь и появляется фигура Романа Шлыкова — маркетолога-практика, который подошел
          к проблеме не как теоретик, а как человек, работавший с реальными рекламными кампаниями,
          большими массивами данных и вопросами точности маркетинговой аналитики. Как Marketing
          Director Netpeak Ukraine, он был напрямую вовлечен в digital-среду, где от корректности
          учета кликов, пользовательских взаимодействий, конверсий и итогового ROI зависят и
          бюджетные решения, и стратегические выводы, и доверие к самой аналитике. Именно из этой
          профессиональной логики вырос его патент «Способ анализа эффективности маркетинговых
          кампаний с использованием технологии блокчейн».
        </p>

        <p className="p-1">
          По сути, Шлыков предложил использовать блокчейн не как модный технологический аксессуар,
          а как способ заново выстроить саму среду учета маркетинговых событий. Если ключевые точки
          рекламной воронки — клик, взаимодействие, конверсия, результат кампании — фиксируются в
          распределенном реестре, они перестают быть просто строками в отчете и становятся
          защищенными записями, которые нельзя незаметно переписать, скорректировать задним числом
          или исказить без следа. В этом и состоит центральная идея его разработки: все
          взаимодействия пользователей с рекламными материалами, а также все конверсии и результаты
          кампаний записываются в блокчейн и затем используются для анализа, проверки
          достоверности и построения отчетности. Такой подход выглядит логичным продолжением его
          опыта в digital-маркетинге: чем сложнее рекламные системы и выше цена ошибки, тем важнее
          не просто собирать данные, а делать их проверяемыми и защищенными на уровне самой
          архитектуры.
        </p>

        <p className="p-1">
          На уровне здравого смысла это меняет довольно многое. Обычная маркетинговая аналитика
          отвечает на вопрос: что показывают данные? Блокчейн-подход добавляет к этому другой,
          более фундаментальный вопрос: почему этим данным можно доверять? Разница кажется
          небольшой, но именно она разделяет две модели работы. В первой бизнес опирается на
          отчеты. Во второй — на события, происхождение и целостность которых можно проверить.
          Для зрелого рынка это принципиальный переход. Потому что в маркетинге давно важно не
          только уметь считать результат, но и уметь обосновать, почему этот результат следует
          считать достоверным.
        </p>

        <p className="p-1">
          Самая понятная точка входа в эту тему — клик. В digital-рекламе клик выглядит почти
          элементарной единицей: человек увидел объявление, нажал, перешел. Но на практике именно
          вокруг кликов часто и начинаются вопросы. Насколько корректно они атрибутированы? Нет ли
          дублей? Нет ли технических расхождений между кабинетами и внутренней аналитикой? Не
          теряются ли связи между рекламным событием и последующим действием? Когда клик
          фиксируется как отдельное событие в защищенной и неизменяемой среде, он перестает быть
          просто оперативной метрикой и становится частью более устойчивой цепочки доказательств.
          Это не отменяет анализа качества трафика, но создает гораздо более прочную основу для
          его учета.
        </p>

        <p className="p-1">
          Конверсии в этой логике становятся еще важнее. Именно вокруг них чаще всего вращается
          спор об эффективности: какой канал реально привел клиента, какой этап воронки сработал,
          где произошел решающий сдвиг, как учитывать повторные касания, как распределять ценность
          между источниками трафика. Когда конверсия существует только как запись в очередной
          аналитической системе, она неизбежно зависит от конфигурации этой системы. Когда же она
          фиксируется как защищенное событие в распределенном реестре, сама основа для дальнейшего
          спора становится прочнее. Компания получает не просто “цифру в дашборде”, а событие,
          которое включено в прозрачную последовательность взаимодействий.
        </p>

        <p className="p-1">
          Но, пожалуй, самый чувствительный показатель для бизнеса — это ROI. Возврат инвестиций в
          маркетинг — метрика, от которой зависят бюджеты, доверие к каналам, оценка подрядчиков и
          стратегические решения. В реальности ROI почти никогда не является чисто математическим
          показателем: он опирается на массу исходных допущений. Какие события признаны
          конверсией? Какие расходы включены в расчет? Насколько надежны данные о действиях
          пользователя? Блокчейн в этой системе играет роль не калькулятора, а доверенной основы.
          Если база событий защищена от незаметных изменений, то и итоговая оценка возврата
          инвестиций становится менее спорной. Именно поэтому в патенте отдельно подчеркивается
          рост точности и достоверности оценки ROI как один из ключевых результатов применения
          технологии.
        </p>

        <p className="p-1">
          Важно и то, что распределенный реестр решает не только проблему доверия, но и проблему
          зависимости. В традиционной модели компания часто зависит от внешних аналитических
          систем, от подрядчиков, от внутренних согласований, от необходимости перепроверять
          расхождения между несколькими источниками. Когда маркетинговые события изначально
          хранятся в прозрачной и защищенной среде, сама стоимость проверки снижается. Аналитика
          становится не только более надежной, но и более управляемой. В патентной модели это
          выражается в сокращении потребности в сторонней верификации и аудите, а значит — и в
          снижении затрат на сам процесс анализа.
        </p>

        <p className="p-1">
          Отдельный эффект связан с доверием вне маркетингового отдела. Для команды performance или
          digital прозрачность данных важна сама по себе. Но для собственников, инвесторов,
          руководства и партнеров это уже вопрос другого уровня: насколько можно опираться на
          маркетинговые цифры при принятии решений? Чем крупнее компания и чем серьезнее рекламные
          инвестиции, тем выше ценность среды, где результаты можно не просто красиво показать, а
          независимо подтвердить. Поэтому блокчейн здесь работает не только как технология учета,
          но и как технология институционального доверия. Не случайно среди результатов применения
          решения прямо выделяется повышение доверия со стороны инвесторов, клиентов и партнеров.
        </p>

        <p className="p-1">
          Скептик в этот момент справедливо спросит: хорошо, но остается ли все это только красивой
          теорией? Именно поэтому особенно важны примеры практического применения. Один из них
          связан с Rozetka, где технология использовалась для создания более прозрачной и
          проверяемой системы маркетинговой аналитики. Эффект оказался не декоративным, а вполне
          операционным: клиентский трафик вырос на 18%, доверие со стороны клиентов и партнеров
          увеличилось на 30%, а расходы на аудит маркетинговых данных снизились. Уже здесь видно,
          что блокчейн в маркетинге может работать не как футуристическая надстройка, а как решение
          для повседневных бизнес-задач.
        </p>

        <p className="p-1">
          Но самое интересное начинается, когда смотришь на внутренние последствия такой
          технологии. В случае Rozetka она повлияла не только на прозрачность отчетности, но и на
          скорость управленческой реакции. Более точное измерение ROI, более быстрая корректировка
          стратегий, снижение затрат на анализ, уменьшение времени обработки данных на 35% — все
          это означает, что распределенный реестр влияет не только на точность отчета, но и на
          ритм принятия решений. Рекламные расходы сократились на 15%, эффективность маркетинговых
          усилий выросла на 20%, конверсия увеличилась на 25%, customer acquisition — на 18%, а
          средний ROI рекламных кампаний — на 12%. В совокупности это показывает: надежность
          данных начинает работать как производительный актив бизнеса.
        </p>

        <p className="p-1">
          Кейс MTS раскрывает другую сторону той же идеи. В крупной телеком-компании технология
          применялась для автоматизации маркетинговой аналитики и отслеживания ROI. Здесь блокчейн
          оказался полезен не только как средство контроля, но и как инфраструктурное решение:
          маркетинговые расходы сократились на 14%, вовлеченность пользователей выросла на 11%, а
          внутри компании появилась собственная блокчейн-платформа для безопасного хранения и
          анализа рекламных взаимодействий. Это особенно важно, потому что показывает
          масштабируемость подхода: если в e-commerce ключевыми становятся конверсии и скорость
          оптимизации, то в корпоративной среде на первый план выходят надежность данных,
          управляемость процессов и устойчивость аналитической системы в целом.
        </p>

        <p className="p-1">
          В этом смысле блокчейн в маркетинге вообще не стоит понимать слишком узко. Это не история
          о том, что “теперь все кампании должны идти через блокчейн”. Скорее, это история о смене
          стандарта. Рынок постепенно приходит к тому, что данных мало просто иметь. Их нужно
          уметь защищать, подтверждать и использовать так, чтобы на них можно было опереться в
          условиях высокой стоимости ошибки. Реклама давно перестала быть просто инструментом
          охвата и стала системой инвестиционных решений. А там, где начинаются инвестиции,
          неизбежно растет ценность доверенной среды учета.
        </p>

        <p className="p-1">
          Поэтому вопрос “зачем фиксировать клики, конверсии и ROI в распределенном реестре?” на
          самом деле шире, чем кажется. Ответ не сводится к защите от фальсификаций. Речь идет о
          переходе от маркетинга, который верит данным, к маркетингу, который умеет их защищать.
          От отчетности как формы убеждения — к аналитике как форме доказательства. От зависимости
          от разрозненных систем — к более цельной архитектуре доверия. Именно в этом и
          заключается значение такой технологии: она не просто помогает лучше считать рекламу, а
          меняет саму основу разговора об эффективности.
        </p>

        <p className="p-1">
          И, возможно, именно поэтому распределенный реестр начинает выглядеть в маркетинге не как
          экзотика, а как один из наиболее логичных ответов на зрелость рынка. Когда бюджеты
          растут, каналы множатся, а решений становится все больше, главным дефицитом оказывается
          уже не объем данных, а уверенность в них. И тот, кто первым научится превращать
          маркетинговые события в по-настоящему доверенную систему, получит преимущество не только
          в аналитике, но и в скорости, качестве и смелости стратегических решений.
        </p>
      </div>
    </div>
  );
}

export default ArticlePage19;